/**
 * Ccategoryicon Component
 * Displays a team category icon based on the TeamCategory enum
 */
'use client';
import type { CSSProperties } from 'react';
import { TeamCategory } from '@cabal/shared/domain/session/team/enums.js';
import { Cimage } from '../Cimage';
import { dataEl, type DataElScope } from '@/utils/dataEl';
const CATEGORY_ICON_PATHS: Record<TeamCategory, string> = {
    [TeamCategory.OPS]: '/icons/ops.png',
    [TeamCategory.CORTEX]: '/icons/cortex.png',
    [TeamCategory.ARCADE]: '/icons/arcade.png',
    [TeamCategory.VITALS]: '/icons/vitals.png',
};
export const CATEGORY_ICON_SHADOW_INTENSITY = {
    Intense: 'intense',
    Mild: 'mild',
} as const;
export type ShadowIntensity = (typeof CATEGORY_ICON_SHADOW_INTENSITY)[keyof typeof CATEGORY_ICON_SHADOW_INTENSITY];
export interface CcategoryiconProps {
    dataElScope: DataElScope;
    category: TeamCategory;
    size?: number;
    opacity?: number;
    shadowIntensity?: ShadowIntensity;
    style?: CSSProperties;
    priority?: boolean;
}
export function Ccategoryicon({ dataElScope, category, size = 20, opacity = 1, shadowIntensity = CATEGORY_ICON_SHADOW_INTENSITY.Intense, style, priority = false, }: CcategoryiconProps) {
    const shadowStyles: Record<ShadowIntensity, string> = {
        [CATEGORY_ICON_SHADOW_INTENSITY.Intense]: '#ffffff91 1px 2px 4px -2px inset, #ffffff21 -1px -1px 2px 0px inset, #00000099 0px 0px 3px 1px, #00000015 0px 0px 0px 5px',
        [CATEGORY_ICON_SHADOW_INTENSITY.Mild]: 'rgba(255, 255, 255, 0.57) 1px 2px 2px -2px inset, rgba(255, 255, 255, 0.13) -1px -1px 2px 0px inset, rgba(0, 0, 0, 0.3) 0px 0px 4px 0px, rgba(0, 0, 0, 0.082) 0px 0px 1px 3px',
    };
    const containerStyle: CSSProperties = {
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 1,
        boxShadow: shadowStyles[shadowIntensity],
        backgroundColor: '#ffffff07',
        ...style,
    };
    return (
    <div data-el={dataEl(dataElScope, 'Root')} style={containerStyle}>
            <Cimage src={CATEGORY_ICON_PATHS[category]} alt={category} width={size} height={size} static={true} priority={priority} objectFit="cover" style={{
            width: '100%',
            height: '100%',
            opacity,
        }}/>
        </div>
      );
}
